module.exports = __webpack_public_path__ + "img/1-1PZ1110622195.dcb9c8d8.png";